import React from 'react';
import Alert from 'react-s-alert';
import ReactDOMServer from 'react-dom/server';
import DropzoneComponent from 'react-dropzone-component';
import * as cookie from 'react-cookies';
import { AUTH_TOKEN } from '../utils/CookiesManager';
import { ApiEndpoints } from '../webservices/endpoint';
import { I18nUtils } from '../../../i18n/I18nUtils';
import PropTypes from 'prop-types';
import FileTypeRequest from '../../documents/ws/FileTypeRequest';
import UploadRequest from '../../profile/ws/UploadRequest';

export class FormDropzone extends React.Component {

    dropzone;

    constructor(props) {
        super(props);

        this.state = {
            dicMimeTypeId: {},
            numAttachedFiles: 0,
        };
    }

    componentDidMount() {
        new FileTypeRequest()
            .onSuccess(this.handleSetFileTypesByMime)
            .execute();
    }

    render() {
        const { errorMessage } = this.props;
        const postUrl = new UploadRequest().determineHostname() + ApiEndpoints.UPLOAD;
        const config = { postUrl };
        const djsConfig = this.handleConfig();
        const eventHandlers = this.handleEventHandlers();

        return [
            <div className="col-sm-12">
                <div className={'form-group'}>
                    <DropzoneComponent
                        config={config}
                        djsConfig={djsConfig}
                        eventHandlers={eventHandlers}
                    >
                        <div className="dz-message">
                            <div className="drag-icon-cph">
                                <i className="material-icons">touch_app</i>
                            </div>
                            <h3>{I18nUtils.tr('TR_ARRASTRE_FICHEROS_AQUI_O_HAGA_CLICK_PARA_SUBIR')}</h3>
                        </div>
                        <div className="fallback">
                            <input
                                name="file"
                                type="file"
                                multiple
                            />
                        </div>
                    </DropzoneComponent>
                    {
                        errorMessage && errorMessage.length !== 0 &&
                        <label className="error">
                            {errorMessage}
                        </label>
                    }
                </div>
            </div>,
        ];
    }

    handleConfig = () => (
        {
            maxFiles: this.props.maxFiles,
            addRemoveLinks: true,
            dictRemoveFile: I18nUtils.tr('TR_ELIMINAR'),
            dictRemoveFileConfirmation: I18nUtils.tr('TR_ESTA_SEGURO_DE_QUE_QUIERE_ELIMINAR_EL_ARCHIVO'),
            dictCancelUpload: I18nUtils.tr('TR_CANCELAR'),
            dictCancelUploadConfirmation: I18nUtils.tr('TR_ESTA_SEGURO_DE_QUE_QUIERE_CANCELAR_LA_SUBIDA'),
            acceptedFiles: this.props.mimeTypesAccepted, // Eg.: `image/*,application/pdf,.psd`
            previewTemplate: this.handleConfigPreviewTemplate(),
            init: undefined,
            headers: {
                'Authorization': 'Bearer ' + cookie.load(AUTH_TOKEN),
            },
        }
    );

    // Maquetación del ítem mostrado dentro del dropzone
    handleConfigPreviewTemplate = () => {
        return ReactDOMServer.renderToStaticMarkup(
            <div className="dz-preview dz-file-preview">
                <div className="dz-image">
                    <img data-dz-thumbnail alt={''}/>
                </div>
                <div className="dz-details">
                    <div className="dz-size">
                        <span data-dz-size/>
                    </div>
                    <a className={'link'} href={''} target={'_blank'}>
                        <div className="dz-filename">
                            <span>Vista previa</span>
                        </div>
                    </a>
                </div>
                <div className="dz-progress">
                    <span className="dz-upload" data-dz-uploadprogress/>
                </div>
                <div className="dz-error-message">
                    <span data-dz-errormessage/>
                </div>
                <div className="dz-success-mark"/>
                <div className="dz-error-mark"/>
            </div>,
        );
    };

    handleEventHandlers = () => ( {
        init: this.handleInit,
        success: this.handleSuccess,
        complete: this.handleComplete,
        canceled: this.handleCanceled,
        addedfile: this.handleAddedFile,
        error: this.handleError,
        removedfile: this.handleRemovedFile,
    } );

    handleInit = (dropzone) => {
        this.dropzone = dropzone;
    };

    handleSuccess = (file, response) => {
        const { value, onChange } = this.props.input;
        const { dicMimeTypeId } = this.state;
        const newFiles = [
            ...value,
            {
                file: response.data.url,
                name: file.name,
                size: file.size,
                mimeType: file.type,
                fileTypeId: dicMimeTypeId[file.type],
                uuid: file.upload.uuid,
            },
        ];
        onChange(newFiles);
    };

    handleComplete = (file) => {
        const link = file.previewTemplate.getElementsByClassName('link');
        const response = file.xhr && JSON.parse(file.xhr.response);
        if ( response ) {
            link[0].href = response.data.url;
            this.props.onSubmitDisabled(false);
        }
    };

    handleCanceled = () => {
        this.props.onSubmitDisabled(false);
    };

    handleAddedFile = (file) => {
        this.setState({ numAttachedFiles: this.state.numAttachedFiles + 1 });
    };

    handleError = (file) => {
        if ( file.accepted ) return;
        if ( this.dropzone ) this.dropzone.removeFile(file);
        this.handleErrorMessage();
    };

    handleErrorMessage = () => {
        if (this.props.maxFiles === this.state.numAttachedFiles) {
            Alert.error(I18nUtils.tr('TR_HAS_ADJUNTADO_EL_NUMERO_MAXIMO_DE_FICHEROS'));
        } else {
            Alert.error(I18nUtils.tr('TR_ERROR_FICHERO_NO_PERMITIDO'));
        }
    }

    handleRemovedFile = (file) => {
        const { value, onChange } = this.props.input;
        const newFiles = value.filter(f => f.uuid !== file.upload.uuid);
        onChange(newFiles);
        this.setState({ numAttachedFiles: this.state.numAttachedFiles - 1 });
    };

    handleSetFileTypesByMime = (res) => {
        const mimeTypes = res.data;
        const dicMimeTypeId = {};
        mimeTypes.forEach(mimeType => {
            mimeType.mime_types.forEach(mT => {
                dicMimeTypeId[mT] = mimeType.id;
            });
        });
        this.setState({ dicMimeTypeId });
    };

}

FormDropzone.propTypes = {
    mimeTypesAccepted: PropTypes.array,
    onSubmitDisabled: PropTypes.func.isRequired,
    maxFiles: PropTypes.number,
    errorMessage: PropTypes.string,
};

FormDropzone.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/FormDropzone.js